module.exports = __webpack_public_path__ + "fonts/Calibre-SemiboldItalic.8f3e4b3e.woff2";